(function ($, window) {
    let prodigy_product_tabs = {

        init: function () {
            this.set_product_tabs();
            this.set_tabs_desktop_aria_attributes();
            this.set_mobile_aria_attributes();
            this.show_tab_review();
            this.show_tab_description();
        },

        set_product_tabs: function () {
            $('.description_tab').addClass('active');
            $('#tab-additional_information').hide();
            $('#tab-reviews').hide();


            $('body')
                // Tabs
                .on(
                    'init',
                    '.prodigy-tabs-js, .prodigy-tabs',
                    function () {
                        $('.pg-tab, .prodigy-tabs .panel:not(.panel .panel)').hide();
                        let hash = window.location.hash;
                        let url = window.location.href;
                        let $tabs = $(this)
                            .find('.pg-tabs, ul.tabs')
                            .first();
                        if (
                            hash.toLowerCase().indexOf('comment-') >= 0 ||
                            hash === '.prodigy-reviews' ||
                            hash === '#tab-reviews'
                        ) {
                            $tabs.find('li.reviews_tab a').click();
                        } else if (
                            url.indexOf('comment-page-') > 0 ||
                            url.indexOf('cpage=') > 0
                        ) {
                            $tabs.find('li.reviews_tab a').click();
                        } else if (hash === '#tab-additional_information') {
                            $tabs.find('li.additional_information_tab a').click();
                        } else {
                            let $tab = $tabs.find('li:first a');
                            let $tabs_wrapper = $tab.closest('.prodigy-tabs-js, .prodigy-tabs');
                            $tabs.find('li').removeClass('active');
                            $tabs_wrapper.find('.pg-tab, .panel:not(.panel .panel)').hide();

                            $tab.addClass('active');
                            $tabs_wrapper.find($tab.data('href')).show();
                        }
                    },
                )
                .on(
                    'click',
                    '.pg-tabs li a, ul.tabs li a',
                    function (e) {
                        let $tab = $(this);
                        let $tabs_wrapper = $tab.closest('.prodigy-tabs-js, .prodigy-tabs');
                        let $tabs = $tabs_wrapper.find('.pg-tabs, ul.tabs');

                        $tabs.find('li').removeClass('active');
                        $tabs_wrapper.find('.pg-tab, .panel:not(.panel .panel)').hide();

                        $tab.closest('li').addClass('active');
                        $tabs_wrapper.find($tab.data('href')).show();
                    },
                )

                // Star ratings for comments
                .on(
                    'init',
                    '#prodigy-rating',
                    function () {
                        $(this)
                            .hide()
                            .before(
                                '' +
                                '<div class="stars prodigy-comment__rating">' +
                                '<a class="star-1 prodigy-comment__star icon icon-star" href="#">1</a>' +
                                '<a class="star-2 prodigy-comment__star icon icon-star" href="#">2</a>' +
                                '<a class="star-3 prodigy-comment__star icon icon-star" href="#">3</a>' +
                                '<a class="star-4 prodigy-comment__star icon icon-star" href="#">4</a>' +
                                '<a class="star-5 prodigy-comment__star icon icon-star" href="#">5</a>' +
                                '</div>',
                            );
                    },
                )
                .on(
                    'click',
                    '#respond div.stars a',
                    function () {
                        let $star = $(this),
                            $rating = $(this)
                                .closest('#respond')
                                .find('#prodigy-rating'),
                            $container = $(this).closest('.stars');
                        $rating.val($star.text()).trigger('change');
						for (let i=1;i<=$star.text();i++) {
							$container.find('.star-' + i).addClass('selected');
						}
                        // $star.siblings('a').removeClass('active');
                        // $star.addClass('active');
                        // $container.addClass('selected');

                        return false;
                    },
                )

                .on(
                    'click',
                    '.prodigy-reviews .prodigy-comments .justify-content-center',
                    function () {
                        window.prodigyProduct
                            .get_count_review()
                            .done(
                                function (result) {
                                    let count_review = result.data;
                                    if (count_review > 0) {
                                        window.prodigyProductReview.get_content_review();
                                    }
                                },
                            )
                            .fail(
                                function () {
                                },
                            );
                    },
                );

            $('.prodigy-tabs-js, .prodigy-tabs, #prodigy-rating').trigger('init');
            this.set_tabs_desktop_aria_attributes();
        },

        set_tabs_desktop_aria_attributes: function () {
            $(document).on('click', '.pg-tabs li a, ul.tabs li a', function (e) {
                let $tab = $(this);
                let $tabs_wrapper = $tab.closest('.prodigy-tabs-js, .prodigy-tabs');

                $tabs_wrapper.find('.panel').each(function () {
                    let $panel = $(this);
                    let isActivePanel = $panel.css('display') === 'block';
                    $panel.attr('aria-hidden', isActivePanel ? 'false' : 'true');
                });
            });
        },

        set_mobile_aria_attributes: function () {
            $(document).on('show.bs.collapse hide.bs.collapse', '.collapse', function (event) {
                if (event.type === 'show') {
                    $(this).attr('aria-hidden', 'false');
                } else if (event.type === 'hide') {
                    $(this).attr('aria-hidden', 'true');
                }
            });
        },


        show_tab_description: function () {
            $('body').on(
                'click',
                '.show-description-js',
                function () {
                    $('.description_tab').addClass('active').show();
                    $('#tab-description').show();
                    $('#tab-li-reviews').removeClass('active');
                    $('.additional_information_tab').removeClass('active');
                    $('.reviews_tab').removeClass('active');
                    $('.tiered_prices_tab').removeClass('active');
                    $('#tab-additional_information').hide();
                    $('#tab-reviews').hide();
                    $('#tab-tiered_prices').hide();
                },
            );
        },

        show_tab_review: function () {
            $('body').on(
                'click',
                '.prodigy-review-link-js',
                function () {
                    $('#tab-reviews').addClass('active').show();
                    $('#tab-li-reviews').addClass('active');
                    $('#tab-description').hide();
                    $('#tab-additional_information').hide();
                    $('#tab-tiered_prices').hide();
                    $('.description_tab').removeClass('active');
                    $('.tiered_prices_tab').removeClass('active');
                    $('.additional_information_tab').removeClass('active');
                    $('.reviews_tab').addClass('active');
                    if (document.getElementById('tab-reviews')) {
                        document.getElementById('tab-reviews').scrollIntoView();
                    }
                },
            );
        },


    };
    window.prodigyProductTabs = prodigy_product_tabs;
    })(jQuery, window);

    jQuery(document).ready(
        function ($) {
            window.prodigyProductTabs.init();
        }
    );
